export const englishOnlyLocales = [
    "accents",
    "as",
    "en-pt",
    "en-x-rtl",
    "fv",
    "lol",
    "or",
    "pa", // The Punjabi team wants all timestamps to be in English only, CP-5508
    "rw", // TODO(CP-5556): Create a proper config file
    "sgn-us",
    "xh",
    "zu",
];

export const specialCases = {
    "fa-af": "fa",
    hy: "hy-am",
    pt: "pt-br",
    "pt-pt": "pt",
    // Our Serbian site is translated into the Cyrillic script, so
    // timestamps in moment.js should also use Cyrillic.
    sr: "sr-cyrl",
    // Conversely, Uzbek wants to use Latin instead of
    // Moment's default Cyrillic.
    uz: "uz-latn",
    "zh-hans": "zh-cn",
    "zh-hant": "zh-tw",
};

/**
 * A map of KA locales to moment locales.
 */
export const kaLocaleToMoment = (kaLocale) =>
    (englishOnlyLocales.includes(kaLocale) && "en") ||
    specialCases[kaLocale] ||
    kaLocale;
